<template>
  <div class="rule-basics">
    <p>You found the Oddball! The majority has won! Kindly reveal your words to each other now.</p>
    <router-link to="/words"><b-button class="next-button">Play again and get new words!</b-button></router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>